define('app/sdc/cached/collection/sdc-cached-collection-factory',["$parse"], function ($parse) {
	"use strict";
	return function sdcCachedCollectionFactory(trackBy) {
		var parsedTrackBy = arguments.length ? $parse(trackBy) : function (context) { return context; };
		var items = {};
		return {
			getOrAddMany: function getOrAddMany(items) {
				return angular.map(items, this.getOrAdd.bind(this));
			},
			getOrAdd: function getOrAdd(item) {
				var trackBy;
				if (!item) {
					return item;
				}
				else {
					trackBy = angular.toJson(parsedTrackBy(item));
					if (Object.hasOwnProperty.call(items, trackBy)) {
						return items[trackBy];
					}
					else {
						return items[trackBy] = item;
					}
				}
			},
			setMany: function setMany(item) {
				return angular.map(items, this.addOrUpdate.bind(this));
			},
			set: function set(item) {
				var trackBy;
				if (!item) {
					return item;
				}
				else {
					trackBy = angular.toJson(parsedTrackBy(item));
					return items[trackBy] = item;
				}
			},
			get: function get(trackValue) {
				trackBy = angular.toJson(trackValue);
				return items[trackBy] = item;
			},
			getMany: function getMany(trackValues) {
				return angular.map(trackValues, this.get.bind(this));
			}
		};
	}
});
